import { render, staticRenderFns } from "./MigrationMemberTableItem.vue?vue&type=template&id=12905d92&scoped=true&"
import script from "./MigrationMemberTableItem.vue?vue&type=script&lang=js&"
export * from "./MigrationMemberTableItem.vue?vue&type=script&lang=js&"
import style0 from "./MigrationMemberTableItem.vue?vue&type=style&index=0&id=12905d92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12905d92",
  null
  
)

export default component.exports